import React from 'react';
import {
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const AlertDialog = ({
  isOpen,
  title,
  content,
  onClose,
  onConfirm,
  showClose,
  confirmBtnCaption,
}) => {
  const { t } = useTranslation();

  const handleYes = () => {
    onConfirm();
    onClose();
  };

  const handleNo = () => {
    onClose();
  };

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={isOpen}>
      {title && (
        <DialogTitle id="confirmation-dialog-title">
          <Typography color="primary" variant="subtitle1">
            {title}
          </Typography>
        </DialogTitle>
      )}
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        {showClose && (
          <Button onClick={handleNo} color="primary">
            {t('no')}
          </Button>
        )}
        <Button onClick={handleYes} color="primary">
          {confirmBtnCaption || t('ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AlertDialog.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showClose: PropTypes.bool,
  content: PropTypes.string,
  onConfirm: PropTypes.func,
  confirmBtnCaption: PropTypes.string,
};

export default AlertDialog;
